import React from 'react'
import {cx} from '@emotion/css'
import styled from '@emotion/styled'
import {OfferModeSwitcher} from 'components/OfferModeSwitcher/OfferModeSwitcher'

import {DefaultPictureWrapper} from '@vio/atlas/Avatar/Avatar'
import {Button} from '@vio/atlas/Button'
import {NoStyleButton} from '@vio/atlas/helpers/NoStyleButton'
import {Icon} from '@vio/atlas/Icon'
import {cssTheme} from '@vio/atlas/themes'
import {User} from '@vio/core/src/auth/types/Cognito'
import {UserAvatar} from '@vio/shared/src/user/account/UserAvatar'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  &.--has-inverse-header {
    color: ${cssTheme.colors.content.neutral.inverse};

    .--mobile-header-avatar {
      box-shadow: none;
      ${DefaultPictureWrapper} {
        background-color: ${cssTheme.colors.background.brand.secondary};
        color: ${cssTheme.colors.content.brand.primary};
      }
    }
  }
  &.--neutral-menu-text {
    color: ${cssTheme.colors.content.neutral.primary};
  }
`

interface Props {
  onShowPreferences?: () => void
  shouldShowUserAvatar: boolean
  user?: User
  hasInverseHeader?: boolean
  hasNeutralMobileMenuText?: boolean
}
export const MobileHeaderMenu = ({
  onShowPreferences,
  shouldShowUserAvatar,
  user,
  hasInverseHeader = false,
  hasNeutralMobileMenuText = false
}: Props) => {
  return (
    <Wrapper
      className={cx(
        hasInverseHeader && '--has-inverse-header',
        hasNeutralMobileMenuText && '--neutral-menu-text'
      )}
    >
      <OfferModeSwitcher
        variant={hasInverseHeader ? 'ghostInverse' : 'ghost'}
      />
      {shouldShowUserAvatar && user ? (
        <NoStyleButton
          onClick={onShowPreferences}
          data-id="ShowPreferencesButton"
          data-testid="ShowPreferencesButton"
        >
          <UserAvatar user={user} className="--mobile-header-avatar" />
        </NoStyleButton>
      ) : (
        <Button
          onClick={onShowPreferences}
          dataId="ShowPreferencesButton"
          variant="ghost"
          iconStart={
            <Icon
              name="Menu"
              colorPath={
                hasInverseHeader
                  ? 'content.neutral.inverse'
                  : 'content.neutral.primary'
              }
            />
          }
        />
      )}
    </Wrapper>
  )
}
